import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'

export const contactsContextNewDocumentsTabPivotTableKey = 'contactsContext.selected.newDocumentsTab.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({
    key: contactsContextNewDocumentsTabPivotTableKey,
    defaultSortColumn: 'folderName',
  }),
})
